// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

export function validateUruguayanZipcode(zipcodeValue: string): ?UserInputValidationError {
  if (!zipcodeValue || !zipcodeValue.trim())
    return { id: 'empty' };
  else if (!/^[0-9]{5}$/.test(zipcodeValue))
    return { id: 'invalid-pattern' };
}
